import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { TokenExpirationProvider } from "./contexts/TokenExpirationContext";
import Login from "./pages/auth/Login";
import PublicDashboard from "./pages/Dashboard/PublicDashboard";
import Dashboard from "./pages/Dashboard/Dashboard";
import BloodRequests from "./pages/blood/BloodRequests";
import BloodRequestDetails from "./pages/blood/BloodRequestDetails";
import BloodRequestForm from "./pages/blood/BloodRequestForm";
import InOutRecords from "./pages/InOutRecords";
import Campaigns from "./pages/campaigns/Campaigns";
import CreateCampaign from "./pages/campaigns/CreateCampaign";
import CampaignDonationScreen from "./pages/campaigns/CampaignDonationScreen";
import Profile from "./pages/user/Profile";
import BillingHistory from "./pages/user/BillingHistory";
import Notifications from "./pages/Notifications";
import Layout from "./components/layout/Layout";
import LoadingSpinner from "./components/common/LoadingSpinner";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/public-dashboard" replace />
  );
};

// Main App Routes Component
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/public-dashboard" element={<PublicDashboard />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* Hospital Routes */}
        <Route path="inout-records" element={<InOutRecords />} />
        <Route path="blood-requests" element={<BloodRequests />} />
        <Route path="blood-requests/new" element={<BloodRequestForm />} />
        <Route path="blood-requests/:id" element={<BloodRequestDetails />} />

        {/* BDO Routes */}
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="create-campaign" element={<CreateCampaign />} />
        <Route path="campaign-donations" element={<CampaignDonationScreen />} />

        {/* Profile Routes */}
        <Route path="profile" element={<Profile />} />

        {/* Billing History Route */}
        <Route path="billing-history" element={<BillingHistory />} />

        {/* Notifications Route */}
        <Route path="notifications" element={<Notifications />} />

        {/* Catch all route - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/public-dashboard" replace />} />
      </Route>
    </Routes>
  );
};

// Main App Component
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TokenExpirationProvider>
          <div className="min-h-screen bg-gray-50">
            <AppRoutes />
          </div>
        </TokenExpirationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
